<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            valueChanges: valueChanges$ | async,
            required: required$ | async
        } as data"
    >
        <bazis-grid
            class="bazis-grid_form"
            [formGroup]="dateIntervalForm"
        >
            <bazis-row>
                <bazis-col size="6">
                    <bazis-input-date
                        formControlName="from"
                        [titleKey]="dateFromTitleKey"
                        [hasEraser]="false"
                        [popperOptions]="popperOptions"
                        [placeIcon]="placeIcon"
                        [placeholderKey]="dateFromPlaceholderKey"
                        [mode]="mode"
                        [sizeControl]="sizeControl"
                        #dateFromCpm
                    ></bazis-input-date>
                </bazis-col>
                <bazis-col size="6">
                    <bazis-input-date
                        formControlName="to"
                        [titleKey]="dateToTitleKey"
                        [hasEraser]="false"
                        [popperOptions]="popperOptions"
                        [placeIcon]="placeIcon"
                        [placeholderKey]="dateToPlaceholderKey"
                        [mode]="mode"
                        [sizeControl]="sizeControl"
                        #dateToCpm
                    ></bazis-input-date>
                </bazis-col>
            </bazis-row>
        </bazis-grid>
        <bazis-display-error
            *ngIf="dateIntervalForm.errors?.invalidIntervalDate"
            errorKey="invalidIntervalDate"
        ></bazis-display-error>

        <bazis-button
            class="bh-block bh-margin-top-3x"
            color="action"
            [disabled]="
                dateIntervalForm.invalid ||
                (!dateIntervalForm.controls['from'].value && !dateIntervalForm.controls['to'].value)
            "
            (click)="dateApply()"
        >
            {{ t('title.apply') }}
        </bazis-button>
    </ng-container>
</ng-container>
